import { useEffect, useState } from "react";
import { _IncidentReport, _single } from "../../../core/services/dataBean/EntityCatalog";
import useDataBean from "../../../core/services/dataBean/useDataBean";
import usePaginator from "../../theme/Component/usePaginator";
import { toast } from "react-toastify";
import { ListMenu } from "../../theme/Component/ListMenu";
import { BasicPage } from "../../theme/Component/BasicPage";
import { BasicTable, MASK_MYEDITOR } from "../../theme/Component/BasicTable";
import { Modal } from "../../theme/Component/Modal";
import useModal, { MODAL_LG, MODAL_md } from "../../theme/Component/hooks/useModal";
import { TracingIncidentReport } from "./TracingIncidentReport/TracingIncidentReport";
import { FileInput } from "../../theme/Component/FileInput";

interface menuProps {
    adminMenu?: boolean;
}

export const IncidentReport = ({ adminMenu }: menuProps) => {

    const { instance, bean, setBean, lista, setLista } = useDataBean(_IncidentReport);
    const [info, setInfo] = useState<any>({});
    const paginator = usePaginator();

    const modal = useModal("", MODAL_LG);
    const modalAdd = useModal("", MODAL_LG);
    const modalAddDoc = useModal("", MODAL_md);
    const modalAddNote = useModal("", MODAL_md);

    useEffect(() => {
        getLista();
    }, [paginator.page]);

    const getLista = () => {
        const props: any = {}
        if (!adminMenu === true) props.IDEmployee = _single.getAccountID();

        instance.getIncidentReport(paginator.page, 15, props).then(
            (resp: any) => {
                paginator.setPages(resp.NumberOfPages);
                paginator.setRecords(resp.NumberOfPages * 15);

                setLista(resp.List);
            }
        ).catch(err => {
            toast.error("Error al cargar la lista de incidentes");
        });
    };

    const head = [
        { title: 'Codigo', property: 'IncidenceCode', visible: true },
        { title: 'Descripción', property: 'Description', visible: true, mask: MASK_MYEDITOR },
        { title: 'Usuario', property: 'EntityName', visible: true },
        { title: 'Fecha', property: 'Since', visible: true },
        { title: 'Estado', property: 'StateName', visible: true },

    ];

    const create = () => {
        setBean({});
        modalAdd.open("Reportar Incidencia")
    }

    const iconButtonsItem = [
        { nombre: 'Agregar', visible: _single.canCreate(), icono: 'ri-file-add-line', evento: create }
    ]

    const listaBotones = () => {
        const botones = [
            { titulo: 'ver seguimiento', icono: 'ri-edit-2-line', visible: _single.canEdit(), evento: () => { modal.open(`Seguimiento`) } },
            { titulo: 'Agregar Documentos', icono: 'ri-file-upload-line', visible: _single.canEdit() && (bean.State != 90 && bean.State != 80), evento: () => { modalAddDoc.open(`Agregar documentos de seguimiento`) } },
            { titulo: 'Agregar Notas', icono: 'ri-sticky-note-line', visible: _single.canEdit() && (bean.State != 90 && bean.State != 80), evento: () => { modalAddNote.open(`Agregar una Nota al incidente`) } },
        ]
        return (
            <ListMenu listaBotones={botones} />
        )
    }

    const addNote = () => {
        if (!bean.Note.trim()) {
            toast.error("Debe ingresar una nota")
            return;
        }
        instance.addNoteToIncident(bean.IncidenceCode, bean.Note, bean.Media, bean.MediaContext).then(
            (resp) => {
                if (resp.ERR) {
                    toast.error(resp.ERR);
                    return;
                } else {
                    setBean({});
                    modalAddNote.close();
                    toast.success("Nota agregada")
                }
            }
        ).catch(err => { toast.error("No se pudo agregar la nota") })
    }

    const addDocument = () => {
        if (!bean.Media.trim()) {
            toast.error("Debe selecionar un archivo")
            return;
        }
        instance.addAttachtoIssue(bean.IncidenceCode, bean.Media, bean.MediaContext).then(
            (resp) => {
                if (resp.ERR) {
                    toast.error(resp.ERR);
                    return;
                } else {
                    toast.success("Documento agregado")
                    setBean({});
                    modalAddDoc.close();
                }
            }
        ).catch(err => {
            console.log(err)
            toast.error("No se pudo agregar el documento")
        })
    }

    const createIncident = () => {
        instance.createIncidentReport(_single.getAccountID(), bean.Description).then(
            (resp) => {
                if (resp.ERR) {
                    toast.error(resp.ERR);
                    return;
                } else {
                    toast.success("Incidente creado");
                    modalAdd.close();
                    setBean({});
                    getLista();
                }
            }
        ).catch(
            error => {
                toast.error(error)
            }
        )
    }

    const getIncidentDetail = async () => {
        try {
            const resp = await instance.getIncidentReportByIncidentCode(
                _single.getAccountID(),
                bean.IncidenceCode
            );

            setInfo(resp);

            if (resp.Status !== bean.State) {
                await syncState(resp.Status);
            }

        } catch (err) {
            toast.error("Error al consultar incidente");
        }
    };

    const syncState = async (status: number) => {
        try {
            const resp = await instance.changeIncidentReportStatus(
                bean.IDIncidentReport,
                status
            );
            setBean(resp);

            getLista();

        } catch (err) {
            console.log(err);
        }
    };

    useEffect(() => {
        if (!bean.IncidenceCode || !bean.IDIncidentReport) return;

        getIncidentDetail();

    }, [bean.IncidenceCode]);

    return (
        <BasicPage titulo="Lista de Incidencias">
            <div className="row">
                <div className="col-md-12">
                    <BasicTable
                        body={lista}
                        head={head}
                        rowSet={setBean}
                        listButtons={listaBotones()}
                        iconButtons={iconButtonsItem}
                        records={paginator}
                    />

                    {/* <PrintJson json={info} /> */}

                    <Modal modal={modal.modal} updateModal={modal.setModal}>
                        <div className="row">
                            <div className="col-md-12">
                                <TracingIncidentReport IncidentCode={bean.IncidenceCode} incidentData={info} />
                            </div>
                        </div>
                    </Modal>

                    <Modal modal={modalAdd.modal} updateModal={modalAdd.setModal} eventModal={() => { createIncident() }}>
                        <div className="row">
                            <div className="col-md-12">
                                <label>Descripción de la Incidencia</label>
                                <textarea maxLength={1000} placeholder="¿En qué podemos ayudarte? Describe tu solicitud con el mayor detalle posible." rows={10} className="form-control" value={bean.Description} onChange={(e) => { setBean({ ...bean, Description: e.target.value }) }}></textarea>
                            </div>
                        </div>
                    </Modal>

                    <Modal modal={modalAddDoc.modal} updateModal={modalAddDoc.setModal} eventModal={() => { addDocument() }}>
                        <div className="row">
                            <div className="col-md-12">
                                <FileInput label="Arhcivo que desea agregar" onCreate={(e) => { setBean({ ...bean, Media: e.Media, MediaContext: e.MediaContext }) }} />
                            </div>
                        </div>
                    </Modal>

                    <Modal modal={modalAddNote.modal} updateModal={modalAddNote.setModal} eventModal={() => { addNote() }}>
                        <div className="row">
                            <div className="col-md-12">
                                <label>Nota</label>
                                <textarea maxLength={1000} placeholder="Maximo 1000 caracteres" rows={5} className="form-control" value={bean.Note} onChange={(e) => { setBean({ ...bean, Note: e.target.value }) }}></textarea>
                            </div>
                            <div className="col-md-12">
                                <FileInput label="Arhcivo de la nota" onCreate={(e) => { setBean({ ...bean, Media: e.Media, MediaContext: e.MediaContext }) }} />
                            </div>
                        </div>
                    </Modal>
                </div>
            </div >
        </BasicPage >
    )
}